<div class="content position-relative register-page" [ngStyle]="{
    backgroundColor: (Merchant$ | async)?.webapp_settings
      ?.homepage_bottom_color,
  }">
  <section class="page-content d-flex align-items-center justify-content-center flex-fill">
    <div class="login-box">
      <div class="login-box-body">
        <form #RegistrationForm="ngForm" (ngSubmit)="attempRegistration(RegistrationForm)" novalidate>
          <div class="row row-cols-2">
            <div class="col">
              <div class="form-group">
                <label [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_homepgae,
                                  }">First Name</label>
                <input type="text" name="FirstName" required ngModel class="form-control form-control-lg" placeholder="First Name" />
                @if (
                RegistrationForm.controls["FirstName"]?.invalid &&
                (RegistrationForm.controls["FirstName"].dirty ||
                RegistrationForm.controls["FirstName"].touched)
                ) {
                <div>
                    @if (
                    RegistrationForm.controls["FirstName"].errors.required
                    ) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Enter First Name
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_homepgae,
                                  }">Last Name</label>
                <input type="text" name="LastName" ngModel required class="form-control form-control-lg" placeholder="Last Name" />
                @if (
                RegistrationForm.controls["LastName"]?.invalid &&
                (RegistrationForm.controls["LastName"].dirty ||
                RegistrationForm.controls["LastName"].touched)
                ) {
                <div>
                    @if (
                    RegistrationForm.controls["LastName"].errors.required
                    ) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Enter Last Name
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label
                  [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }"
                  >Country</label
                >
                <ng-select
                  class="ng-select-md"
                  bindLabel="name"
                  name="ddlcountry"
                  required
                  [items]="Country"
                  (change)="ValueChange($event)"
                  [(ngModel)]="selectedCountry"
                  placeholder="-- Select Country --"
                >
                </ng-select>
                @if (
                RegistrationForm.controls["ddlcountry"]?.invalid &&
                (RegistrationForm.controls["ddlcountry"].dirty ||
                RegistrationForm.controls["ddlcountry"].touched)
                ) {
                <div>
                    @if (
                    RegistrationForm.controls["ddlcountry"].errors.required
                    ) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please select Country
                    </span>
                    }
                    </div>
                }
                <!-- <ng-select class="ng-select-md" [items]="SelectOption" placeholder="-- Select country --"></ng-select> -->
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_homepgae,
                                  }">Country Code</label>
                <input type="text" name="dialcode" required [value]="dialcode" disabled class="form-control form-control-lg"
                  placeholder="Country Code" />
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_homepgae,
                                  }">Mobile #</label>
                <input type="number" name="Mobile" required ngModel class="form-control form-control-lg" placeholder="Mobile #" />
                @if (
                RegistrationForm.controls["Mobile"]?.invalid &&
                (RegistrationForm.controls["Mobile"].dirty ||
                RegistrationForm.controls["Mobile"].touched)
                ) {
                <div>
                    @if (RegistrationForm.controls["Mobile"].errors.required) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Enter Mobile No.
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label
                  [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }"
                  >Password</label
                >
                <input
                  type="password"
                  name="Password"
                  required
                  ngModel
                  class="form-control form-control-lg"
                  placeholder="Password"
                />
                @if (
                  RegistrationForm.controls["Password"]?.invalid &&
                  (RegistrationForm.controls["Password"].dirty ||
                    RegistrationForm.controls["Password"].touched)
                ) {
                  <div>
                    @if (
                    RegistrationForm.controls["Password"].errors.required
                    ) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Enter Password.
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label
                  [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }"
                  >Repeat</label
                >
                <input
                  type="password"
                  name="Rpassword"
                  required
                  ngModel
                  class="form-control form-control-lg"
                  placeholder="Password"
                />
                @if (
                  RegistrationForm.controls["Rpassword"]?.invalid &&
                  (RegistrationForm.controls["Rpassword"].dirty ||
                    RegistrationForm.controls["Rpassword"].touched)
                ) {
                  <div>
                    @if (
                    RegistrationForm.controls["Rpassword"].errors.required
                    ) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Re-enter Password.
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label
                  [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }"
                  >Email</label
                >
                <input
                  type="email"
                  name="Email"
                  required
                  ngModel
                  class="form-control form-control-lg"
                  placeholder="Email address"
                />
                @if (
                  RegistrationForm?.controls["Email"]?.invalid &&
                  (RegistrationForm.controls["Email"].dirty ||
                    RegistrationForm.controls["Email"].touched)
                ) {
                  <div>
                    @if (RegistrationForm?.controls["Email"].errors.required) {
                    <span [ngStyle]="{
                                              color: (Merchant$ | async)?.webapp_settings
                                                ?.menu_font_color_homepgae,
                                            }">
                      please Email Password.
                    </span>
                    }
                    </div>
                }
              </div>
            </div>
            <div class="col-12">
              <div class="form-group ml-3 pl-1">
                <input class="form-check-input" style="width: 20px; height: 20px" type="checkbox" [(ngModel)]="isPolicy"
                  (change)="PolicyPopup(1, $event)" name="isAccept" />
                <label class="form-check-label" [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_homepgae,
                                    'font-size': 'medium',
                                    padding: '4px',
                                  }">
                  <a target="_blank" href="https://www.toodleglobal.com/terms-of-business/">Accept Terms & Conditions</a>
                </label>
              </div>
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" (ngSubmit)="attempRegistration(RegistrationForm)" [disabled]="!isPolicy"
              class="btn btn-lg mt-2"
              [ngStyle]="{
                backgroundColor: (Merchant$ | async)?.webapp_settings
                  ?.menu_color,
                color: (Merchant$ | async)?.webapp_settings
                  ?.menu_font_color_homepgae,
                border:
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }"
            >
              Sign Up
            </button>
          </div>
        </form>
      </div>
      <div class="login-box-footer clearfix text-center">
        <!-- <div class="sign-up-link mt-4">
        <a routerLink="/forgot-password" class="text-white"> Sign In</a>
      </div> -->
        <div class="text-center mt-4" [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_homepgae,
                  }">
          by continuing you agree to our <br /><a href="https://www.toodleglobal.com/terms-of-business/" target="_blank">Terms</a>
          and
          <a target="_blank" href="https://www.toodleglobal.com/privacy-policy/">Privacy Policy</a>
        </div>
      </div>
    </div>
  </section>
  <div id="myModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <div class="modal-header" [ngStyle]="{
                'justify-content': 'right',
                height: '40px',
                backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                'border-bottom':
                  (Merchant$ | async)?.webapp_settings?.menu_border_width +
                  'px solid ' +
                  (Merchant$ | async)?.webapp_settings?.menu_border_color,
              }">
        <a (click)="close()" id="btnnotification" class="close-icon">
          <i [ngStyle]="{
                        color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                      }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
      </div>
      <div class="modal-body">
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
                    'white-space': 'break-spaces',
                  }" id="textcontent">
          I confirm that I have read the
          <a target="_blank" href="https://www.toodleglobal.com/privacy-policy/" style="text-decoration: underline">Privacy Policy
          </a>
          and I consent to Payar collecting information (see sections: Active
          and Passive Collection of Information) and using it for operational
          purposes (see section: Use of Information Collected) and sharing it
          with select third party service providers enabling them to perform the
          relevant service(s) (see section 'Sharing of Information')
          <br /><br />
          *Please ensure that location services are enabled for your browser
          else you will not be able to place orders with this application.*
        </p>
      </div>
      <div class="modal-footer">
        <button
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border:
              (Merchant$ | async)?.webapp_settings?.menu_border_width +
              'px solid ' +
              (Merchant$ | async)?.webapp_settings?.menu_border_color,
          }"
          (click)="PolicyPopup(2)"
        >
          Decline
        </button>
        <button
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border:
              (Merchant$ | async)?.webapp_settings?.menu_border_width +
              'px solid ' +
              (Merchant$ | async)?.webapp_settings?.menu_border_color,
          }"
          (click)="PolicyPopup(3)"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</div>
